

























































import SimpleMap from '../../core/components/SimpleMap.vue';
import $ from 'jquery';
import {
    EventBus,
    hasElements,
    TypeEventBus,
    sortObjectByPropertyName,
    checkIfIDExistsInArray,
    getDateFromTimestamp,
    getIdsFromList,
    removeItemsFromList,
    matchedIndexIdInArray,
    getUniqueId,
    formatDate,
    downloadFile
} from '../../core/utils';
import { Destroyed } from '../../core/decorators';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import { PRIVILEGE_KEYS, PRIVILEGE_TYPES } from '../../core/utils/privileges';
import DatePickerSingle from '../../core/components/DatePickerSingle.vue';
import SimpleTable from '../../core/components/SimpleTable.vue';
import WorkSegments from './WorkSegments.vue';
import IgnoredPeriods from './IgnoredPeriods.vue';
import ForcePeriodsSowing from './ForcePeriodsSowing.vue';
import ManualFactors from './ManualFactors.vue';
import ModalViewAllCard from './ModalViewAllCard.vue';
import Button from '../../core/components/Button.vue';
import { booleanFormatter, getOnlyDateFromTimestamp, nullFormatter } from '../../core/utils/table-formatters';
import DeleteConfirmation from '../../tracking/components/Geofences/DeleteConfirmation.vue';
import {
    MsgBox,
    Combobox,
    LoadingDialog,
    PlusEyeButtons,
    Breadcrums,
    CloseConfirmationModal
} from '../../core/components';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import DatePickerRange from '../../core/components/DatePickerRange.vue';
import multiselect from 'vue-multiselect';
import Axios from 'axios';
import { InsuranceServices } from '../api/InsuranceServices';
import Loading from 'vue-loading-overlay';
import { config } from 'rxjs';
import moment from 'moment';

@Component({
    components: {
        Loading,
        Combobox,
        SimpleMap,
        DatePickerSingle,
        DatePickerRange,
        IgnoredPeriods,
        ForcePeriodsSowing,
        ManualFactors,
        Button,
        SimpleTable,
        WorkSegments,
        ModalViewAllCard
    }
})
export default class AnalyticView extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    @Prop() vehicleID: number;
    @Prop({default(){return []}}) currentVehicle: Array<object>;
    @Prop() companyId: number;
    @Prop({ default: false }) isSowing: boolean;
    @Prop({ default: {} }) farmingData: object;
    @Prop({
        default() {
            return [];
        }
    })
    companies: Array<object>;
    @Prop({
        default() {
            return [];
        }
    })
    calibrationPeriods: Array<object>;
    @Prop({
        default() {
            return [];
        }
    })
    farmings: Array<object>;
    @Prop({
        default() {
            return [];
        }
    })
    forcedWorkSegments: Array<object>;
    seeAllManualFactors: boolean = true;
    itemsWorkSegments: Array<object> = [];
    farmingsList: any = [];
    ignoredPeriodsList: any = [];
    forcedPeriods: any = [];
    itemsManualFactors: any = [];
    itemsManualFactorsTable: Array<object> = [];
    companiesList: any = [];
    visibleModalViewAll: boolean = false;
    viewAllType: string = '';

    visibilityModalViewAll(value) {
        this.visibleModalViewAll = value;
    }

    get modalViewAllAnalyticView(): HTMLFormElement {
        return this.$refs.modalViewAllAnalyticView as HTMLFormElement;
    }

    get sctManualFactor(): HTMLFormElement {
        return this.$refs.sctManualFactor as HTMLFormElement;
    }

    get sctIgnoredPeriods(): HTMLFormElement {
        return this.$refs.sctIgnoredPeriods as HTMLFormElement;
    }

    editManualFactor(item) {
        if (this.sctManualFactor) {
            this.sctManualFactor.editManualFactor(item);
        }
    }

    deleteManualFactor(item) {
        if (this.sctManualFactor) {
            this.sctManualFactor.deleteManualFactor(item);
        }
    }

    editIgnoredPeriod(item) {
        if (this.sctIgnoredPeriods) {
            this.sctIgnoredPeriods.editSelectedPeriod(item);
        }
    }

    deleteIgnoredPeriod(item) {
        if (this.sctIgnoredPeriods) {
            this.sctIgnoredPeriods.deleteSelectedPeriod(item);
        }
    }

    viewAllManualFactors() {
        this.viewAllType = 'manualfactors';
        this.visibilityModalViewAll(true);
    }

    viewAllIgnoredPeriods() {
        this.viewAllType = 'ignoredperiods';
        this.visibilityModalViewAll(true);
    }

    reloadModalViewAll() {
        if (this.modalViewAllAnalyticView) {
            this.modalViewAllAnalyticView.getData();
        }
    }

    mounted() {
        this.getAnalyticData();
    }

    getAnalyticData() {
        if (!this.isSowing) {
            this.getHarvestVehicleAnalyticalData();
        } else {
            this.setCompanies(this.companies);
            this.setFarmings(this.farmings);
        }
    }

    getHarvestVehicleAnalyticalData() {
        let self = this;
        if (this.vehicleID !== null) {
            InsuranceServices.getVehicleHarvestAnalticalView(this.vehicleID)
                .then(response => {
                    self.setCompanies(response['companies']);
                    self.setFarmings(response['harvests']);
                    self.setIgnoredPeriods(response['error_lapses']);
                    self.setManualFactors(response['manual_calibrations']);
                })
                .catch(error => {
                    if (error && error.response && error.response.data && error.response.data.message) {
                        this.$_showHistoricalError(error.response.data.message);
                    } else {
                        this.$_showHistoricalError('Ocurrio un error');
                    }
                });
        }
    }

    setCompanies(companies) {
        this.companiesList = [];
        this.companiesList = companies;
    }

    setFarmings(farmings) {
        this.farmingsList = [];
        this.farmingsList = farmings;
    }

    setIgnoredPeriods(ignoredPeriods) {
        this.ignoredPeriodsList = [];
        this.ignoredPeriodsList = ignoredPeriods;
    }

    setManualFactors(items) {
        this.itemsManualFactors = [];
        this.itemsManualFactors = items;
    }

    @Emit()
    refreshAnalyticView(){}


}
